export const LANDLORD = {
  brand: "Ricky Rooms Lettings",
  name: "Ricky Rooms Lettings",
  title: "Professional Lettings Service",
  statement:
    "At Ricky Rooms Lettings, we provide a straightforward and professional service, with clear tenancy terms, responsive property management and a dedicated team available to assist you throughout your tenancy.",
  phone: "07838 216026",
  phoneHref: "https://wa.me/447838216026",
  email: "ricky@rickyrooms.co.uk",
  emailHref: "mailto:ricky@rickyrooms.co.uk",
  office: "Ricky Rooms Lettings — quality homes, flats & rooms",
  hours: "Message us any time on WhatsApp — we usually reply within 2 hours",
  emergency: "Responsive property management for active tenants",
  licences: [
    { id: 1, name: "Licence / Accreditation 1", text: "Add your licence logo and details here" },
    { id: 2, name: "Licence / Accreditation 2", text: "Add your licence logo and details here" },
    { id: 3, name: "Licence / Accreditation 3", text: "Add your licence logo and details here" },
    { id: 4, name: "Licence / Accreditation 4", text: "Add your licence logo and details here" },
  ],
};
